import { render, staticRenderFns } from "./GSelectorEx.vue?vue&type=template&id=5106e82e&"
import script from "./GSelectorEx.vue?vue&type=script&lang=ts&"
export * from "./GSelectorEx.vue?vue&type=script&lang=ts&"
import style0 from "./GSelectorEx.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports